import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import * as crud from "./../application/Admin/_redux/users/usersCrud";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

export function DashboardPage() {
  const { user } = useSelector((state) => state.auth);
  const userobject = user?.userData || user || {};
  const userName = userobject.name || (userobject.email ? userobject.email.split('@')[0] : "Admin");

  const dashboard_data = {}

  const [dashboard, setDashboard] = useState(dashboard_data)
  const [processing, setProcessing] = useState(true)
  const loadUsers = async () => {
    let response = await crud.getDashboardRecord()
    let dashboard_response = response.data
    if (dashboard_response.status === "success") {
      let data = {
        users_totalCount: dashboard_response.users_totalCount,
        approved_users_totalCount: dashboard_response.approved_users_totalCount,
        

        reported_business: dashboard_response.reported_business,
        pending_business: dashboard_response.pending_business,
        pending_sub_categories: dashboard_response.pending_sub_categories,
        pending_categories: dashboard_response.pending_categories,
        
        inactive_app_users: dashboard_response.inactive_app_users,
        inactive_categories: dashboard_response.inactive_categories,
        
       
        business_totalCount: dashboard_response.business_totalCount,
        appusers_totalCount: dashboard_response.appusers_totalCount,
        categories_totalCount: dashboard_response.categories_totalCount,
        sub_categories_totalCount: dashboard_response.sub_categories_totalCount,

        paid_business_totalCount: dashboard_response.paid_business_totalCount,
      }
      setDashboard(data)
      setProcessing(false)
    }
  }

  useEffect(() => {
    loadUsers()
  }, []);

  return (
    <>
      <div className="card card-custom gutter-b bg-light-primary border-0 mb-6">
        <div className="card-body py-5 px-6 d-flex align-items-center justify-content-between flex-wrap">
          <div className="d-flex align-items-center">
            <div className="symbol symbol-50 symbol-light-primary mr-4">
              <span className="symbol-label font-size-h3 font-weight-bolder text-primary">
                {userName ? userName.charAt(0).toUpperCase() : "A"}
              </span>
            </div>
            <div>
              <h2 className="text-dark font-weight-bolder mb-1">
                Hello, {userName}! 👋
              </h2>
              <span className="text-muted font-weight-bold font-size-sm">
                Welcome back to your Link For All Admin Dashboard. Here is your overview for today.
              </span>
            </div>
          </div>
          <div className="my-2">
            <span className="badge bg-white text-dark-75 font-weight-bolder px-4 py-3 font-size-sm shadow-xs border">
              <i className="fa fa-calendar-alt text-primary mr-2"></i>
              {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })}
            </span>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-4 col-md-6">
          <div className="card card-custom bg-warning gutter-b">
            <div className="card-body p-5" style={{display: "grid",gridTemplateColumns: "80% 20%",alignItems:"center"}} >
              <div>
                <div className="text-inverse-primary font-weight-bolder dashboard-counter mt-3">
                  {(processing)?<></>:dashboard.reported_business}
                </div>
                <a href="/business/reported" className="text-inverse-primary font-weight-bold font-size-h5 mt-1">Reported Businesses</a>
              </div>
              <span className="svg-icon svg-icon-4x svg-icon-secondary">
                {
                  (processing)? 
                    <i className="fas fa-circle-notch fa-spin"></i>
                    :
                    <SVG src={toAbsoluteUrl( "/media/svg/icons/Communication/Group.svg" )} ></SVG>
                }
             </span>
              
            </div>
          </div>
        </div>
        
        <div className="col-lg-4 col-md-6">
          <div className="card card-custom bg-warning gutter-b">
            <div className="card-body p-5" style={{display: "grid",gridTemplateColumns: "80% 20%",alignItems:"center"}} >
              <div>
                <div className="text-inverse-primary font-weight-bolder dashboard-counter mt-3">{dashboard.pending_business}</div>
                <a href="/business/pending" className="text-inverse-primary font-weight-bold font-size-h5 mt-1">Pending Businesses</a>
              </div>
              <span className="svg-icon svg-icon-4x svg-icon-secondary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Group.svg"
                  )}
                ></SVG>
              </span>
              
            </div>
          </div>
        </div>
                    
        {/* <div className="col-lg-4 col-md-6">
          <div className="card card-custom bg-warning gutter-b">
            <div className="card-body p-5" style={{display: "grid",gridTemplateColumns: "80% 20%",alignItems:"center"}} >
              <div>
                <div className="text-inverse-primary font-weight-bolder dashboard-counter mt-3">{(processing)?<></>:dashboard.pending_sub_categories}</div>
                <a href="/subcategory/pending" className="text-inverse-primary font-weight-bold font-size-h5 mt-1">Pending Sub Categories</a>
              </div>
              <span className="svg-icon svg-icon-4x svg-icon-secondary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Group.svg"
                  )}
                ></SVG>
              </span>
              
            </div>
          </div>
        </div> */}

        <div className="col-lg-4 col-md-6">
          <div className="card card-custom bg-warning gutter-b">
            <div className="card-body p-5" style={{display: "grid",gridTemplateColumns: "80% 20%",alignItems:"center"}} >
              <div>
                <div className="text-inverse-primary font-weight-bolder dashboard-counter mt-3">{(processing)?<></>:dashboard.pending_categories}</div>
                <a href="/category/pending" className="text-inverse-primary font-weight-bold font-size-h5 mt-1">Pending Categories</a>
              </div>
              <span className="svg-icon svg-icon-4x svg-icon-secondary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Group.svg"
                  )}
                ></SVG>
              </span>
              
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6">
          <div className="card card-custom bg-success gutter-b">
            <div className="card-body p-5" style={{display: "grid",gridTemplateColumns: "80% 20%",alignItems:"center"}} >
              <div>
                <div className="text-inverse-primary font-weight-bolder dashboard-counter mt-3">{dashboard.appusers_totalCount}</div>
                <a href="/user" className="text-inverse-primary font-weight-bold font-size-h5 mt-1">Total App Users</a>
              </div>
              <span className="svg-icon svg-icon-4x svg-icon-secondary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Group.svg"
                  )}
                ></SVG>
              </span>
              
            </div>
          </div>
        </div>
        
        <div className="col-lg-4 col-md-6">
          <div className="card card-custom bg-success gutter-b">
            <div className="card-body p-5" style={{display: "grid",gridTemplateColumns: "80% 20%",alignItems:"center"}} >
              <div>
                <div className="text-inverse-primary font-weight-bolder dashboard-counter mt-3">{dashboard.business_totalCount}</div>
                <a href="/business" className="text-inverse-primary font-weight-bold font-size-h5 mt-1">Total Businesses</a>
              </div>
              <span className="svg-icon svg-icon-4x svg-icon-secondary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Group.svg"
                  )}
                ></SVG>
              </span>
              
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6">
          <div className="card card-custom bg-success gutter-b">
            <div className="card-body p-5" style={{display: "grid",gridTemplateColumns: "80% 20%",alignItems:"center"}} >
              <div>
                <div className="text-inverse-primary font-weight-bolder dashboard-counter mt-3">{dashboard.categories_totalCount}</div>
                <a href="/category" className="text-inverse-primary font-weight-bold font-size-h5 mt-1">Total Categories</a>
              </div>
              <span className="svg-icon svg-icon-4x svg-icon-secondary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Group.svg"
                  )}
                ></SVG>
              </span>
              
            </div>
          </div>
        </div>
       
        {/* Total Sub Categories removed */}
              
        <div className="col-lg-4 col-md-6">
          <div className="card card-custom bg-primary gutter-b">
            <div className="card-body p-5" style={{display: "grid",gridTemplateColumns: "80% 20%",alignItems:"center"}} >
              <div>
                <div className="text-inverse-primary font-weight-bolder dashboard-counter mt-3">{dashboard.paid_business_totalCount}</div>
                <a href="/business" className="text-inverse-primary font-weight-bold font-size-h5 mt-1">Premium Business</a>
              </div>
              <span className="svg-icon svg-icon-4x svg-icon-secondary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Group.svg"
                  )}
                ></SVG>
              </span>
              
            </div>
          </div>
        </div>
              
      </div>
    </>


  );
}
